import instance from "@/utils/require.js"

// 客户管理--客户分页查询
export function apiCustomerSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/search",
		method: "post",
		data
	})
}

// 客户管理--添加客户
export function apiCustomerAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/add",
		method: "post",
		data
	})
}

// 客户管理--修改客户
export function apiCustomerUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/update",
		method: "post",
		data
	})
}

// 客户管理--涂鸦PID查询
export function apiCustomerPidSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/pid/search",
		method: "post",
		data
	})
}

// 客户管理--导出涂鸦PID
export function apiCustomerPidExport(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/pid/export",
		method: "post",
		data
	})
}

// 客户管理--添加涂鸦PID
export function apiCustomerPidAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/pid/add",
		method: "post",
		data
	})
}

// 客户管理--修改涂鸦PID
export function apiCustomerPidUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/pid/update",
		method: "post",
		data
	})
}

// 客户管理--客户插件查询
export function apiCustomerPluginSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/plug_in/search",
		method: "post",
		data
	})
}

// 客户管理--新增客户插件
export function apiCustomerPluginAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/plug_in/add",
		method: "post",
		data
	})
}

// 客户管理--修改客户插件
export function apiCustomerPluginUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/plug_in/update",
		method: "post",
		data
	})
}

// 客户管理--删除客户插件
export function apiCustomerPluginDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/plug_in/delete",
		method: "post",
		data
	})
}

// 客户管理--禁用客户插件
export function apiCustomerPluginDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/plug_in/disable",
		method: "post",
		data
	})
}

// 客户管理--启用客户插件
export function apiCustomerPluginEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/plug_in/enable",
		method: "post",
		data
	})
}

// 客户管理--客户插件类别
export function apiCustomerPluginType(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/customer_plug_in_type",
		method: "post",
		data
	})
}

// 客户管理--客户列表
export function apiCustomerList(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/list",
		method: "post",
		data
	})
}

// 客户管理--产品类别
export function apiProductTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/product_type",
		method: "post",
		data
	})
}

// 客户管理--产品型号列表
export function apiProductList(data = {}) {
	return instance({
		url: "/aim/api/v3/product/list",
		method: "post",
		data
	})
}

// 客户管理--插件列表
export function apiCustomerPluginList(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/plug_in/list",
		method: "post",
		data
	})
}